import { createSlice } from '@reduxjs/toolkit';
import { fetchUserIdentifications } from './thunk';
import { UserIdentification } from './types';

interface UserIdentificationsState {
  items: UserIdentification[];
  pagination: {
    count: number;
    next: string | null;
    previous: string | null;
  };
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

const initialState: UserIdentificationsState = {
  items: [],
  pagination: { count: 0, next: null, previous: null },
  status: 'idle',
  error: null,
};

const userIdentificationsSlice = createSlice({
  name: 'userIdentifications',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserIdentifications.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchUserIdentifications.fulfilled, (state, { payload }) => {
        state.status = 'succeeded';
        state.items = payload.results;
        state.pagination = {
          count: payload.count,
          next: payload.next,
          previous: payload.previous,
        };
      })
      .addCase(fetchUserIdentifications.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload ?? action.error.message ?? 'Unknown error';
      });
  },
});

export default userIdentificationsSlice.reducer;
